module.exports = __webpack_public_path__ + "static/media/a28.64e5d6bf.jpg";